import { React, PropTypes, styled } from '../../lib/imports';

import { css } from '@emotion/core';

import { Icon, Text } from '../../components';

const baseStyles = ({ theme }) => css`
  align-items: center;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 90%;
  color: #3f2021;
  background-color: #ffe7e7;
  margin: ${theme.spacings.mega} auto;
  padding: ${theme.spacings.kilo} 23px;
  border-radius: 10px;
`;

const ErrorDiv = styled('div')(baseStyles);

const ErrorContainer = ({ message, margin }) => (
  <ErrorDiv style={{ margin }}>
    <Icon icon='exclamation-triangle' />
    <Text style={{ width: '90%' }}>{message}</Text>
  </ErrorDiv>
);

ErrorContainer.propTypes = {
  message: PropTypes.string,
  margin: PropTypes.string,
};

export default ErrorContainer;
